import { useForm, useFieldArray, Controller, FormProvider } from 'react-hook-form';
import { Button, Grid, Stack, Typography, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';
import React from 'react';

export const OvulationHistoryDetailsForm = ({ onAdd, onClose, setOvulationStudyDialog }) => {
  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    mode: 'all',
    defaultValues: {
      ovulationRows: [{ date: '', day: '', rightOvary: '', leftOvary: '', emr: '', comment: '' }],
    }
  });

  const { handleSubmit, control } = methods;

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'ovulationRows',
  });

  const formSubmit = (formValue) => {
    console.log(formValue, "Form submitted successfully with values!");
    onAdd(formValue);
    setOvulationStudyDialog(false);
  };

  const handleAddRow = () => {
    append({
      date: '',
      day: '',
      rightOvary: '',
      leftOvary: '',
      emr: '',
      comment: '',
    });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(formSubmit)}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          sx={{ borderBottom: 1, borderColor: 'grey.300', paddingBottom: 2 }}
        >
          <Typography variant="h4" fontWeight="bold" sx={{ marginBottom: '2%', fontSize: '1.5rem', color: '#333' }}>
            Ovulation Study
          </Typography>
          <IconButton onClick={onClose} sx={{ color: 'red' }}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </Stack>

        <Grid container spacing={2} sx={{ marginTop: 0 }}>
          <Grid item xs={6} sm={5}>
            <Stack spacing={0.5}>
              <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '65%' }}>
                <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Date</Typography>
                <Controller
                  name="date"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} sx={{ flex: 1 }} type="date" variant="outlined" />
                  )}
                />
              </Stack>

              <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '65%' }}>
                <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>LMP Date</Typography>
                <Controller
                  name="lmp_date"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} sx={{ flex: 1 }} type="date" variant="outlined" />
                  )}
                />
              </Stack>

              <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '65%' }}>
                <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Indication</Typography>
                <Controller
                  name="indication"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} sx={{ flex: 1 }} placeholder="Indication" variant="outlined" />
                  )}
                />
              </Stack>

              <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '65%' }}>
                <Typography sx={{ flex: 0.35, fontWeight: 600, fontSize: '1.2rem' }}>Down Regulation</Typography>
                <Controller
                  name="down_regulation"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} sx={{ flex: 0.4 }} placeholder="Down Regulation" variant="outlined" />
                  )}
                />
                <Typography sx={{ flex: 0.1, fontWeight: 600, fontSize: '1.2rem' }}>Day</Typography>
                <Controller
                  name="day"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} sx={{ flex: 0.4 }} placeholder="Day" variant="outlined" />
                  )}
                />
              </Stack>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={7}>
            <Stack spacing={0.5}>
              <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
                <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.2rem' }}>Tablet</Typography>
                <Controller
                  name="tablet"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} sx={{ flex: 1 }} placeholder="Tablet" variant="outlined" />
                  )}
                />
                <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.2rem' }}>Follow Up Date</Typography>
                <Controller
                  name="follow_up_date"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} sx={{ flex: 1 }} type="date" variant="outlined" />
                  )}
                />
              </Stack>
              <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
                <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.2rem' }}>Injection</Typography>
                <Controller
                  name="injection"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} sx={{ flex: 1 }} placeholder="Injection" variant="outlined" />
                  )}
                />
                <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.2rem' }}>Called For</Typography>
                <Controller
                  name="called_for"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} sx={{ flex: 1 }} placeholder="Called For" variant="outlined" />
                  )}
                />
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        {/* Add Row Button and Table */}
        <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" sx={{ marginTop: 2 }}>
          <Button variant="contained" onClick={handleAddRow}>
            Add Row
          </Button>
        </Stack>

        <TableContainer component={Paper} sx={{ marginTop: 2 }}>
          <Table sx={{ minWidth: 650 }} aria-label="ovulation history table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: 10 }}>Date</TableCell>
                <TableCell sx={{ fontSize: 10 }}>Day</TableCell>
                <TableCell sx={{ fontSize: 10 }}>Right Ovary</TableCell>
                <TableCell sx={{ fontSize: 10 }}>Left Ovary</TableCell>
                <TableCell sx={{ fontSize: 10 }}>EMR</TableCell>
                <TableCell sx={{ fontSize: 10 }}>Comment</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fields.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>
                    <Controller
                      name={`ovulationRows[${index}].date`}
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} fullWidth type="date" variant="outlined" />
                      )}
                    />
                  </TableCell>
                  <TableCell>
                    <Controller
                      name={`ovulationRows[${index}].day`}
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} fullWidth variant="outlined" />
                      )}
                    />
                  </TableCell>
                  <TableCell>
                    <Controller
                      name={`ovulationRows[${index}].rightOvary`}
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} fullWidth variant="outlined" />
                      )}
                    />
                  </TableCell>
                  <TableCell>
                    <Controller
                      name={`ovulationRows[${index}].leftOvary`}
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} fullWidth variant="outlined" />
                      )}
                    />
                  </TableCell>
                  <TableCell>
                    <Controller
                      name={`ovulationRows[${index}].emr`}
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} fullWidth variant="outlined" />
                      )}
                    />
                  </TableCell>
                  <TableCell>
                    <Controller
                      name={`ovulationRows[${index}].comment`}
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} fullWidth variant="outlined" />
                      )}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" sx={{ marginTop: 0.1 }}>
          <Button variant="contained" type="submit">
            Add
          </Button>
          <Button color="error" onClick={onClose}>
            Close
          </Button>
        </Stack>
      </form>
    </FormProvider>
  );
};
